import { render, staticRenderFns } from "./IconRadio.vue?vue&type=template&id=10fe5696&scoped=true&"
import script from "./IconRadio.vue?vue&type=script&lang=js&"
export * from "./IconRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe5696",
  null
  
)

export default component.exports